import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import BrandMark from './BrandMark';

const links = [
  { name: 'Explore', path: '/gallery' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'About', path: '/about' },
];

const linkClass = ({ isActive }) =>
  `px-3 py-2 rounded-md text-sm font-medium transition duration-300 ${
    isActive ? 'text-emerald-700' : 'text-slate-600 hover:text-emerald-600'
  }`;

const MarketingNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useAuth();

  return (
    <nav className="sticky top-0 z-50 border-b border-gold-300/70 bg-parchment/95 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 navbar-safe">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <BrandMark />
          </div>

          <div className="hidden lg:flex items-center space-x-1">
            {links.map((link) => (
              <NavLink key={link.path} to={link.path} className={linkClass}>
                {link.name}
              </NavLink>
            ))}
            <Link
              to={user ? '/gallery' : '/login'}
              className="ml-2 bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2 rounded-md text-sm font-medium transition"
            >
              {user ? 'Open App' : 'Get Started'}
            </Link>
          </div>

          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-slate-600 hover:text-emerald-600 hover:bg-emerald-50 focus:outline-none"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-emerald-100">
            {links.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-md text-base font-medium ${
                    isActive ? 'text-emerald-700 bg-emerald-50' : 'text-slate-600 hover:text-emerald-600 hover:bg-emerald-50'
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </NavLink>
            ))}
            <Link
              to={user ? '/gallery' : '/login'}
              className="block mt-2 bg-emerald-700 hover:bg-emerald-800 text-white px-3 py-2 rounded-md text-base font-medium text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              {user ? 'Open App' : 'Get Started'}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default MarketingNav;
